import { useQueryClient } from "@tanstack/react-query";
import { PropertyRental } from "../../types";
import { EditRentalDetailsDTO } from "../../dtos";
import { editRentalDetails } from "../../api";
import { useDomainMutation } from "@/modules/common/hooks/domain-mutation.hook";

export function useEditPropertyRentalInfo() {
  const queryClient = useQueryClient();

  const mutationEditProperty = useDomainMutation<
    PropertyRental,
    { response?: { data?: { message?: string } } },
    { uid: string; data: EditRentalDetailsDTO }
  >({
    mutationFn: ({
      uid,
      data,
    }: {
      uid: string;
      data: EditRentalDetailsDTO;
    }) => {
      return editRentalDetails(uid, data);
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["track"] });
    },
  });

  return mutationEditProperty;
}
